<template>
    <v-expansion-panels popout>
        <v-expansion-panel>
            <v-expansion-panel-header>
                <div>
                    <v-icon left>mdi-pencil</v-icon>
                    <span class="text-subtitle-1">{{ $t('components.UserDataForm.ShowFormButton') }}</span>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-form ref="changeName" id="changeName" @submit.prevent="changeName">
                    <v-row align="start">
                        <v-col cols="12" sm="4">
                            <span class="d-block text-subtitle-1 pt-4">{{ $t('components.UserDataForm.ChangeNameTitle') }}</span>
                        </v-col>
                        <v-col cols="10" sm="7">
                            <v-text-field 
                                outlined
                                v-model="name"
                                class="dd-input"
                                :label="$t('components.UserDataForm.NameLabel')" 
                                :rules="[requiredRule]" />
                        </v-col>
                        <v-col cols="2" sm="1" class="mt-5">
                            <v-btn icon elevation="0" type="submit">
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                
                <v-divider class="my-6 py-4"/>

                <v-form ref="changePassword" id="changePassword" @submit.prevent="changePassword">
                    <v-row align="start">
                        <v-col cols="12" sm="4">
                            <span class="d-block text-subtitle-1 pt-4">{{ $t('components.UserDataForm.ChangePasswordTitle') }}</span>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field 
                                outlined
                                v-model="password.old"
                                class="dd-input"
                                :type="showPass ? 'text' : 'password'"
                                :label="$t('components.UserDataForm.OldPasswordLabel')" 
                                :rules="[requiredRule, passwordRule]"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPass = !showPass"/>
                        </v-col>
                        <v-col cols="10" sm="3">
                            <v-text-field 
                                outlined
                                v-model="password.new"
                                class="dd-input"
                                :type="showPass ? 'text' : 'password'"
                                :label="$t('components.UserDataForm.NewPasswordLabel')" 
                                :rules="[requiredRule, passwordRule]"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPass = !showPass">
                            </v-text-field>
                        </v-col>
                        <v-col cols="2" sm="1" class="mt-5">
                            <v-btn icon elevation="0" type="submit">
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import AuthAPI from '@/utils/AuthAPI';
import EventBus from '@/utils/EventBus';

/**
 * UserDataForm component includes the required fields and functions to perform 
 * an user information managment process. It allows to change the user name and 
 * password. It uses the AuthAPI class to wrap AWS Cognito service.
 */
export default {
    name: 'UserDataForm',
    data: () => ({
        showPass: false,
        password: {
            old: null,
            new: null
        },
        name: null,
    }),
    props: {
        user: {
            type: Object,
            required: true,
            default: () => ({ name: null })
        }
    },
    mounted() {
        this.name = this.user.name;
    },
    methods: {
        requiredRule(value) { return !!value || 'Required.' },
        passwordRule(value) {
            const $t = this.$t.bind(this);
            if (!value || value.length < 8) return $t('components.ResetPasswordForm.PasswordFullRequirements');
            else if (!value.match('[a-z]+')) return $t('components.ResetPasswordForm.PasswordLowerCaseRequirements');
            else if (!value.match('[A-Z]+')) return $t('components.ResetPasswordForm.PasswordUpperCaseRequirements');
            else if (!value.match('[0-9\\W]+')) return $t('components.ResetPasswordForm.PasswordNumberSymbolRequirements');
            return true;
        },
        async changeName() {
            const [ success, error ] = await AuthAPI.changeName(this.name);
            if (success) {
                EventBus.$emit("userUpdated");
                EventBus.$emit("popup", "Name changed!");
            } else EventBus.$emit("popup", error.message);
        },
        async changePassword() {
            const [ success, error ] = await AuthAPI.changePassword(
                this.password.old, 
                this.password.new
            );

            if (!success) EventBus.$emit("popup", error.message);
            else EventBus.$emit("popup", "Password changed!");
        }
    },
    watch: {
        user(newUser) {
            this.name = newUser.name;
        }
    }
}
</script>